class SizeToggle {
  static getCurrentGender() {
    try {
      return localStorage.getItem("currentSizeGender") || "men";
    } catch (e) {
      console.error("localStorage is not accessible", e);
      return "men";
    }
  }

  constructor(sizeFieldset) {
    this.sizeFieldset = sizeFieldset;
    this.currentGender = SizeToggle.getCurrentGender();
    this.init();
  }

  init() {
    this.toggleContainer = this.sizeFieldset.querySelector(
      ".size-toggle-container"
    );
    this.toggleBtns =
      this.toggleContainer.querySelectorAll(".size-toggle__btn");

    // Create or get the callout element
    this.createCalloutElement();

    this.parseSizes();
    this.applyGenderClasses(this.currentGender);
    this.initializeDisplay();
    this.bindEvents();
    this.updateSelectionCallout(); // Initialize callout text
  }

  createCalloutElement() {
    // Find the add to cart button's parent container
    const addToCartContainer = document.querySelector(".product-form__buttons");

    if (!addToCartContainer) {
      console.error("Could not find add to cart container");
      return;
    }

    // Remove any existing callout elements to prevent duplication
    const existingCallouts = document.querySelectorAll(
      ".size-selection-callout"
    );
    existingCallouts.forEach((callout) => callout.remove());

    // Create the callout element
    this.calloutElement = document.createElement("div");
    this.calloutElement.className = "size-selection-callout";
    this.calloutElement.style.marginBottom = "10px";
    this.calloutElement.style.fontWeight = "bold";
    this.calloutElement.style.fontStyle = "italic";
    this.calloutElement.style.textAlign = "center";

    // Insert before the add to cart container
    addToCartContainer.parentNode.insertBefore(
      this.calloutElement,
      addToCartContainer
    );
  }

  parseSizes() {
    this.sizes = Array.from(
      this.sizeFieldset.querySelectorAll('input[type="radio"]')
    ).map((input) => {
      const label = this.sizeFieldset.querySelector(`label[for="${input.id}"]`);
      let menSize, womenSize;

      if (input.value.includes("/")) {
        [menSize, womenSize] = input.value
          .split("/")
          .map((size) => size.trim().replace(/^M\s*/, "").replace(/^W\s*/, ""));
      } else {
        menSize = input.value.trim().replace(/^M\s*/, "");
        womenSize = null;
      }

      return {
        input,
        label,
        menSize: parseFloat(menSize) || menSize,
        womenSize: womenSize ? parseFloat(womenSize) || womenSize : null,
        isMenOnly: !input.value.includes("/"), // Flag for men-only sizes
      };
    });
  }

  initializeDisplay() {
    // Check if we're on a Nancy product page
    const isNancyProduct = window.location.pathname.includes('/products/the-nancy-');
    
    // If it's a Nancy product, force women's view
    if (isNancyProduct) {
      this.currentGender = 'women';
    }
    
    this.toggleBtns.forEach((btn) => {
      if (btn.dataset.gender === this.currentGender) {
        btn.classList.add("size-toggle__btn--active");
      } else {
        btn.classList.remove("size-toggle__btn--active");
      }
    });
    this.updateSizeDisplay(this.currentGender);
  }

  bindEvents() {
    this.toggleBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        this.toggleGender(e.target.dataset.gender);
      });
    });

    // Add event listeners to the size inputs
    this.sizes.forEach((size) => {
      size.input.addEventListener("change", () => {
        this.updateSelectionCallout();
      });
    });
  }

  applyGenderClasses(gender) {
    if (gender === "women") {
      this.sizeFieldset.classList.add("show-women-sizes");
      this.sizeFieldset.classList.remove("show-men-sizes");
    } else {
      this.sizeFieldset.classList.add("show-men-sizes");
      this.sizeFieldset.classList.remove("show-women-sizes");
    }
  }

  toggleGender(gender) {
    if (this.currentGender === gender) return;

    this.currentGender = gender;
    localStorage.setItem("currentSizeGender", gender);

    this.toggleBtns.forEach((btn) => {
      if (btn.dataset.gender === gender) {
        btn.classList.add("size-toggle__btn--active");
      } else {
        btn.classList.remove("size-toggle__btn--active");
      }
    });

    this.applyGenderClasses(gender);
    this.updateSizeDisplay(gender);
    this.updateSelectionCallout(); // Update the callout when gender changes
  }

  updateSizeDisplay(gender) {
    this.sizes.forEach((size) => {
      // For men-only sizes in women's view, hide both input and label
      if (gender === "women" && size.isMenOnly) {
        size.input.style.display = "none";
        size.label.style.display = "none";
      } else {
        size.input.style.display = "";
        size.label.style.display = "";
      }

      // Update the size label text
      if (gender === "men") {
        size.label.textContent = `${size.menSize}`;
      } else if (gender === "women" && size.womenSize) {
        size.label.textContent = `${size.womenSize}`;
      } else if (gender === "women" && !size.womenSize) {
        size.label.textContent = `${size.menSize}`;
      }
    });
  }

  updateSelectionCallout() {
    if (!this.calloutElement) return;

    // Find the selected size input
    const selectedInput = this.sizes.find((size) => size.input.checked);

    if (!selectedInput) {
      this.calloutElement.textContent = "Please select a size";
      return;
    }

    // Get the appropriate size based on gender
    const gender = this.currentGender;
    const genderCapitalized = gender.charAt(0).toUpperCase() + gender.slice(1);

    let selectedSize;
    if (gender === "men") {
      selectedSize = selectedInput.menSize;
    } else {
      selectedSize = selectedInput.womenSize || selectedInput.menSize;
    }

    // Update the callout text
    this.calloutElement.textContent = `You have selected a ${genderCapitalized}'s size ${selectedSize}`;
  }
}

// Modify initSizeToggle to handle singleton callout
const initSizeToggle = () => {
  const sizeFieldset = document.querySelector(".js-size-fieldset");
  if (!sizeFieldset) return;

  // Check if we've already initialized a SizeToggle for this fieldset
  if (!sizeFieldset.hasAttribute("data-size-toggle-initialized")) {
    const currentGender = SizeToggle.getCurrentGender();
    sizeFieldset.classList.toggle(
      "show-women-sizes",
      currentGender === "women"
    );
    sizeFieldset.classList.toggle("show-men-sizes", currentGender === "men");

    new SizeToggle(sizeFieldset);

    // Mark as initialized to prevent multiple instances
    sizeFieldset.setAttribute("data-size-toggle-initialized", "true");
  }
};

// Clear initialized flags on page load to allow proper re-initialization
document.addEventListener("DOMContentLoaded", () => {
  // Remove existing callouts first
  document
    .querySelectorAll(".size-selection-callout")
    .forEach((callout) => callout.remove());

  // Remove initialization flags
  document
    .querySelectorAll("[data-size-toggle-initialized]")
    .forEach((element) =>
      element.removeAttribute("data-size-toggle-initialized")
    );

  initSizeToggle();
});

document.addEventListener("shopify:section:load", () => {
  // Remove existing callouts first
  document
    .querySelectorAll(".size-selection-callout")
    .forEach((callout) => callout.remove());

  // Remove initialization flags
  document
    .querySelectorAll("[data-size-toggle-initialized]")
    .forEach((element) =>
      element.removeAttribute("data-size-toggle-initialized")
    );

  initSizeToggle();
});

// Modify observer to respect the initialization flag
const observer = new MutationObserver(() => {
  observer.disconnect();
  const sizeFieldset = document.querySelector(".js-size-fieldset");
  if (
    sizeFieldset &&
    !sizeFieldset.hasAttribute("data-size-toggle-initialized")
  ) {
    const currentGender = SizeToggle.getCurrentGender();
    sizeFieldset.classList.toggle(
      "show-women-sizes",
      currentGender === "women"
    );
    sizeFieldset.classList.toggle("show-men-sizes", currentGender === "men");
    initSizeToggle();
  }
  observer.observe(document.body, { childList: true, subtree: true });
});

observer.observe(document.body, { childList: true, subtree: true });
